import React, { useState, useCallback } from 'react';
import { Search, X } from 'lucide-react';
import styles from './search-box.module.css';

interface SearchBoxProps {
  initialValue?: string;
  onSearch: (query: string) => void;
  placeholder?: string;
  showSuggestions?: boolean;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  initialValue = '',
  onSearch,
  placeholder = '搜索游戏...',
  showSuggestions: _showSuggestions = true,
}) => {
  const [query, setQuery] = useState(initialValue);

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  }, [query, onSearch]);

  const handleClear = () => {
    setQuery('');
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.inputWrapper}>
          <Search className={styles.searchIcon} size={18} />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            className={styles.input}
          />
          {query && (
            <button
              type="button"
              onClick={handleClear}
              className={styles.clearBtn}
            >
              <X size={16} />
            </button>
          )}
        </div>
        <button type="submit" className={styles.submitBtn}>
          搜索
        </button>
      </form>
    </div>
  );
};

export default SearchBox;
